import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, X, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export const StickyTrialCTA = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      
      if (scrollPosition > windowHeight * 0.5 && !isDismissed) {
        setIsVisible(true);
      } else if (scrollPosition < windowHeight * 0.3) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  const scrollToDemo = () => {
    const demoSection = document.getElementById('book-demo');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-0"
        >
          <div className="bg-foreground shadow-lg border-t border-background/20">
            <div className="container mx-auto px-4 py-3 md:py-4">
              <div className="flex items-center justify-between gap-4">
                <div className="hidden md:flex items-center gap-3">
                  <div className="flex items-center gap-2 text-primary-foreground">
                    <span className="font-medium">Get hours back from CRM admin every week</span>
                  </div>
                  <span className="text-primary-foreground/60">•</span>
                  <span className="text-primary-foreground/80 text-sm flex items-center gap-1.5">
                    <Users className="w-3.5 h-3.5" />
                    Built for Series B–D revenue teams
                  </span>
                </div>

                <div className="flex md:hidden items-center gap-2 text-primary-foreground">
                  <span className="font-medium text-sm">Know what changed in your pipeline</span>
                </div>

                <div className="flex items-center gap-3">
                  <Button
                    size="lg"
                    variant="secondary"
                    className="font-bold px-6 md:px-8 py-3 group whitespace-nowrap"
                    onClick={scrollToDemo}
                  >
                    Book a Demo
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Button>
                  
                  <button
                    onClick={handleDismiss}
                    className="p-2 text-primary-foreground/60 hover:text-primary-foreground transition-colors"
                    aria-label="Dismiss"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
